import React from 'react'
import Helmet from 'react-helmet'
import PageWrapper from '../components/PageWrapper/PageWrapper'
import IconGrid from '../components/IconGrid/IconGrid'
import styles from './SolutionsPage.module.css'

const SolutionsPage = props => (
  <div className={styles.wrapper}>
    <Helmet
      title="Solutions - Dominion Systems, LLC"
      meta={[
        {
          name: 'description',
          content:
            'Backup & Restoration, Consulting, Workstations, Servers, Disaster Recovery and more.',
        },
      ]}
    />
    <IconGrid heading="Our Solutions" items={props.data.solutions.edges} />
  </div>
)

export default SolutionsPage

export const pageQuery = graphql`
  query pageQuery {
    solutions: allFile(filter: { sourceInstanceName: { eq: "solutions" } }) {
      edges {
        node {
          id
          childMarkdownRemark {
            html
            fields {
              slug
            }
            frontmatter {
              title
              icon
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/solutions.js